(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chic-brand-system"] && !Shopify.designMode) return;
  try {
    
  const chicDeliveryAddServiceDay = (date) => {
    const nextDate = new Date(date);
    nextDate.setHours(12, 0, 0, 0);

    do {
      nextDate.setDate(nextDate.getDate() + 1);
    } while (nextDate.getDay() === 0);

    return nextDate;
  };

  const chicDeliveryFormatDate = (date) => {
    return new Intl.DateTimeFormat('fr-FR', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    }).format(date);
  };

  const chicDeliveryMount = () => {
    const timeline = document.querySelector('[data-chic-delivery]');
    const application = document.querySelector('.sb_ETA');

    if (!timeline || !application || timeline.dataset.ready === 'true') return false;

    const orderDate = new Date();
    const preparationDate = chicDeliveryAddServiceDay(orderDate);
    const deliveryDate = chicDeliveryAddServiceDay(preparationDate);

    timeline.querySelector('[data-chic-order-date]').textContent = chicDeliveryFormatDate(orderDate);
    timeline.querySelector('[data-chic-preparation-date]').textContent = chicDeliveryFormatDate(preparationDate);
    timeline.querySelector('[data-chic-delivery-date]').textContent = chicDeliveryFormatDate(deliveryDate);

    application.insertAdjacentElement('afterend', timeline);
    timeline.hidden = false;
    timeline.dataset.ready = 'true';
    return true;
  };

  if (!chicDeliveryMount()) {
    const chicDeliveryObserver = new MutationObserver(() => {
      if (chicDeliveryMount()) chicDeliveryObserver.disconnect();
    });

    chicDeliveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', chicDeliveryMount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
